import AttendAgreement36Page from './AttendAgreement36Page';

export default AttendAgreement36Page;
